import type { ReaderReportType } from "@/lib/reports/report-type";
import {
  SUBSCRIPTION_COOKIE_NAME,
  SUBSCRIPTION_EVENT_NAME,
} from "./subscription-constants";
import {
  createSubscriptionPreferences,
  hasSubscriptionForEdition,
} from "./subscription-preferences";

const getCookieValue = () => {
  if (typeof document === "undefined") {
    return null;
  }

  const prefix = `${SUBSCRIPTION_COOKIE_NAME}=`;
  const match = document.cookie
    .split(";")
    .map((segment) => segment.trim())
    .find((cookie) => cookie.startsWith(prefix));

  return match ? match.slice(prefix.length) : null;
};

export const isClientSubscribed = ({
  audience,
}: {
  audience?: ReaderReportType;
} = {}) => {
  const cookieValue = getCookieValue();
  const preferences = createSubscriptionPreferences(cookieValue);
  return hasSubscriptionForEdition(preferences, audience);
};

export const onClientSubscribed = (
  listener: (audience?: ReaderReportType) => void
) => {
  if (typeof document === "undefined") {
    return () => {
      // intentionally no-op on the server
    };
  }

  const handler = (event: Event) => {
    const customEvent = event as CustomEvent<{ audience?: ReaderReportType }>;
    listener(customEvent.detail?.audience);
  };

  document.addEventListener(SUBSCRIPTION_EVENT_NAME, handler);

  return () => {
    document.removeEventListener(SUBSCRIPTION_EVENT_NAME, handler);
  };
};

export const emitClientSubscribed = (audience?: ReaderReportType) => {
  if (typeof document === "undefined") {
    return;
  }

  document.dispatchEvent(
    new CustomEvent(SUBSCRIPTION_EVENT_NAME, { detail: { audience } })
  );
};
